import * as React from 'react';
import { Redirect } from 'react-router-dom';
import { Col, Container, Nav, NavItem, NavLink, Row } from 'reactstrap';
import { TR } from 'src/TextRes';
import { ApiLogout, ServerResponse } from '../../api';
import FAIcon from '../fAIcon/FAIcon';
import './CPHeaderLoggedIn.css';

export interface INavBarObject {
    label: string;
    viewName: string;
    hide?: boolean;
}

interface CPHeaderLoggedInState {
    logout: boolean;
    menuOpen: boolean;
}

export default class CPHeaderLoggedIn extends React.PureComponent<any, CPHeaderLoggedInState> {
    constructor(props: any) {
        super(props);
        this.state = {
            logout: false,
            menuOpen: false,
        };
    }

    public render() {
        if (this.state && this.state.logout) {
            return <Redirect to="/logout" />;
        }
        const userName = localStorage.getItem('userName');
        const navigation: INavBarObject[] = [
            { label: TR.cPHeaderLoggedIn_courses, viewName: 'cpcourses' },
            { label: TR.cPHeaderLoggedIn_edit_course, viewName: 'cpcoursedetail', hide: true },
            { label: TR.cPHeaderLoggedIn_teachers, viewName: 'cplecturers' },
            { label: TR.cPHeaderLoggedIn_locations, viewName: 'cplocations' },
            { label: TR.cPHeaderLoggedIn_bookings, viewName: 'cpbookings' },
            { label: TR.cPHeaderLoggedIn_profile, viewName: 'cpprofile' },
        ];

        return (
            <div className="inHeaderBackground">
                <Container>
                    <Row>
                        <Col xs={3} md={1}>
                            <img id="myNavLogo" src="assets/logo_kreis.png" alt="kukundo-logo" />
                        </Col>
                        <Col xs={6} xl={2}>
                            <h3>
                                {navigation.map((navObj: INavBarObject) => {
                                    if (location.hash.startsWith('#/' + navObj.viewName)) {
                                        return navObj.label;
                                    }
                                    return;
                                })}
                            </h3>
                            <div className="usernameClass">{userName}</div>
                        </Col>
                        <Col xs={3} md={5} className="menuIcon text-right">
                            <FAIcon
                                icon="bars"
                                color="#fff"
                                onClick={() => {
                                    this.setState({ menuOpen: !this.state.menuOpen });
                                }}
                            />
                        </Col>
                        <Col xl={9} className={this.state.menuOpen ? 'text-right mopen' : 'text-right mclosed'}>
                            <Nav tabs={true} className="mr-auto panel-tabs active pull-right">
                                {navigation.map((navObj: INavBarObject, index: number) => {
                                    if (navObj.hide) {
                                        return null;
                                    }
                                    return (
                                        <NavItem key={index}>
                                            <NavLink
                                                active={location.hash === '#/' + navObj.viewName ? true : false}
                                                href={'#/' + navObj.viewName}
                                            >
                                                {navObj.label}
                                            </NavLink>
                                        </NavItem>
                                    );
                                })}
                                <span onClick={this.logout}>
                                    <FAIcon icon="sign-out" className="signout" mouseHover="Log out" />
                                </span>
                            </Nav>
                        </Col>
                    </Row>
                </Container>
            </div>
        );
    }
    private logout = () => {
        ApiLogout((sr: ServerResponse) => {
            if (sr.OK) {
                this.setState({ logout: true }, () => {
                    localStorage.setItem('userName', '');
                    localStorage.setItem('authToken', '');
                });
            }
        });
    };
}



// WEBPACK FOOTER //
// ./src/components/cpHeaderLoggedIn/CPHeaderLoggedIn.tsx